import { render, staticRenderFns } from "./SubjectsView.vue?vue&type=template&id=de30c6f4"
import script from "./SubjectsView.vue?vue&type=script&lang=js"
export * from "./SubjectsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports